export const environment = {
    production: false,
    apiUrl: 'https://genexpo.dankospark.co.za/api/'
}